import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import logo from "../../assets/logo.png";
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

const translations = {
  en: {
    createAccount: "Create your account",
    email: "Email",
    password: "Password",
    role: "Role",
    selectRole: "Select your role",
    recruiter: "Recruiter",
    candidate: "Candidate",
    signingUp: "Signing up...",
    signUp: "Sign Up",
    haveAccount: "Already have an account?",
    logIn: "Log in",
    requiredFields: "All fields are required",
    registrationFailed: "Registration failed!",
    errorOccurred: "An error occurred. Please try again later."
  },
  nl: {
    createAccount: "Maak je account aan",
    email: "E-mail",
    password: "Wachtwoord",
    role: "Rol",
    selectRole: "Selecteer je rol",
    recruiter: "Recruiter",
    candidate: "Kandidaat",
    signingUp: "Registreren...",
    signUp: "Registreren",
    haveAccount: "Heb je al een account?",
    logIn: "Inloggen",
    requiredFields: "Alle velden zijn verplicht",
    registrationFailed: "Registratie mislukt!",
    errorOccurred: "Er is een fout opgetreden. Probeer het later opnieuw."
  }
};

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState(3);
  const [lang, setLang] = useState(Cookies.get('isDutch') === 'true' ? 'nl' : 'en');
  const t = translations[lang];
  const navigate = useNavigate();

  useEffect(() => {
    const checkLanguage = () => {
      const cookieIsDutch = Cookies.get('isDutch') === 'true';
      const newLang = cookieIsDutch ? 'nl' : 'en';
      if (newLang !== lang) {
        setLang(newLang);
      }
    };
    checkLanguage();
    const interval = setInterval(checkLanguage, 1000);
    return () => clearInterval(interval);
  }, [lang]);

  const validateForm = () => {
    if (!email || !password) {
      setError(t.requiredFields);
      return false;
    }
    setError('');
    return true;
  };

  const handleSignUp = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_URL}/api/auth/register`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          password: password,
          accountType: role
        }),
      });

      setLoading(false);

      const responseData = await response.json();
      console.log('Response:', responseData);

      if (response.ok && responseData.successful) {
        navigate('/login');
      } else {
        const errorMessage = responseData.error?.message || 
                             responseData.detail?.[0]?.msg ||
                             t.registrationFailed;
        setError(errorMessage);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error:', error);
      setError(t.errorOccurred);
    }
  };

  useEffect(() => {
    console.log(role)
  }, [role])

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSignUp}>
      <div className="form-group">
        <div className='flex w-full justify-center'>
          <img src={logo} alt="Logo" className="logo-image !h-9" />
        </div>
      </div>
        <h1 className='text-3xl font-bold my-6 text-center'>{t.createAccount}</h1>
        <div className="form-group">
          <label htmlFor="email">{t.email}</label>
          <input
            type="email"
            id="email"
            className="form-input border"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">{t.password}</label>
          <input
            type="password"
            id="password"
            className="form-input border"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="role">{t.role}</label>
          <select
            id="role"
            className="form-input border"
            value={role}
            onChange={(e) => setRole(parseInt(e.target.value))}
            required
          >
            <option value="" disabled>{t.selectRole}</option>
            <option value={3}>{t.recruiter}</option>
            <option value={4}>{t.candidate}</option>
          </select>
        </div>
        {error && <p className="mb-4 text-red-500">{error}</p>}
        <div className='flex justify-end'>
          <button type="submit" disabled={loading} className='login-button py-2 px-4 mr-0 w-full'>
            {loading ? t.signingUp : t.signUp}
          </button>
        </div>
        <div className='flex justify-center mt-4'>
          <p className='text-sm text-gray-500'>{t.haveAccount} <Link to="/login" className='text-primary'>{t.logIn}</Link></p>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
